var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("\n    Här får du med ett stolpskydd till varje gavel. Stolpskydden skyddar stolpen vid påkörning.\n  ")])])
}]

export { render, staticRenderFns }